var map = {
	"./app_store_badge.svg": 948,
	"./google_play_store_badge.svg": 949,
	"./grape_account.svg": 659,
	"./grape_app.svg": 950,
	"./grape_coupon.svg": 951,
	"./grape_fave.svg": 952,
	"./grape_instant_shop.svg": 953,
	"./grape_price_promise.svg": 954,
	"./grape_regulars.svg": 955,
	"./grape_reserved.svg": 956,
	"./grape_right_arrow.svg": 957,
	"./grape_shopping_list.svg": 958,
	"./grape_trolley.svg": 660,
	"./old_smart_pass_icon.svg": 959,
	"./save.svg": 1543,
	"./white_copy.svg": 960,
	"./white_right_arrow.svg": 961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 661;